/* eslint-disable no-inner-declarations */
import logger from '../../../utils/src/logger';
import metrics from '../../../utils/src/metrics';
var broadcastAllValues = function (component) {
    var definition = component.__propertiesDefinition;
    // If true, announceValue will make the runtime trigger an event when the
    // component gets attached with the current value of the property, and also
    // broadcast an event every time the value changes.
    for (var propertyName in definition) {
        if (definition[propertyName].announceValue) {
            component.__firePropertyChangeEvent(propertyName);
        }
    }
};
/**
 * Adds support for lifecycle management on a component itself,
 * to notify our runtime when a component has been detached or
 * attached to the DOM.
 */
export var prototypeAdditions;
(function (prototypeAdditions) {
    function hasBeenCreated() {
        this.__created = false;
        this.__defineRegions();
        this.__defineProperties();
        this.__defineElementQueries();
        this.__defineEmbeddedComponents();
        this.__created = true;
        if (this.__callbacks.initialized) {
            this.__callbacks.initialized.apply(this);
        }
        this.__updateImmediately();
    }
    prototypeAdditions.hasBeenCreated = hasBeenCreated;
    function hasBeenDetached() {
        if (this.__componentState === 'detached') {
            logger.error("Detach on " + this.__componentName + " called while component is already detached");
            return;
        }
        this.__componentState = 'detached';
        if (this.__callbacks.detached) {
            this.__callbacks.detached.apply(this);
        }
        this.__destroy();
        this.__detachElementQueries();
    }
    prototypeAdditions.hasBeenDetached = hasBeenDetached;
    function hasBeenAttached() {
        if (this.__componentState === 'attached') {
            logger.error("Attach on " + this.__componentName + " called while component is already attached");
            return;
        }
        if (this.__componentState === 'detached') {
            // we want to be in simmilar situation like after creation
            // some components rely on existence of basic DOM structure (without regions)
            // when being attached
            this.__updateImmediately();
        }
        broadcastAllValues(this);
        this.__attachEmbeddedComponents();
        this.__componentState = 'attached';
        this.node.setAttribute('initialized', true);
        if (this.__callbacks.attached) {
            this.__callbacks.attached.apply(this);
        }
        this.__attachElementQueries();
        // Components can change their internal state in attached callback
        this.__update();
        metrics.logComponentUsed(this);
    }
    prototypeAdditions.hasBeenAttached = hasBeenAttached;
})(prototypeAdditions || (prototypeAdditions = {}));
export function extendComponent(customPrototype, definition) {
    var allowedCallbacks = ['initialized', 'attached', 'detached'];
    var callbacks = definition.callbacks || {};
    for (var callbackName in callbacks) {
        if (allowedCallbacks.indexOf(callbackName) === -1) {
            logger.error('Undefined callback ' + callbackName + ' for component');
        }
    }
    customPrototype.__callbacks = callbacks;
}
//# sourceMappingURL=LifecycleHandling.js.map